import React from "react";
import { NursingQuestionPossibleAnswer } from "../../../../../../messages/VBP";

export interface Props {
  answer: string | null;
  possibleAnswers: NursingQuestionPossibleAnswer[];
  onQuestionClick: (answer: NursingQuestionPossibleAnswer) => void;
}

const VBPQuestionDropDown = (props: Props) => {
  const answer = props.answer !== null ? props.answer : props.possibleAnswers[0].text;

  const handleAnswerClick = React.useCallback(
    (event: any) => {
      const selectedAnswer = props.possibleAnswers.find((a) => a.text === event.target.value);
      if (selectedAnswer !== undefined) {
        props.onQuestionClick.call(null, selectedAnswer);
      }
    },
    [props.onQuestionClick, props.possibleAnswers]
  );

  return (
    <div className="VBPQuestionDropDown">
      <select
        className="ScheduledVisitDocScreen__select ScheduledVisitDocScreen__margin ScheduledVisitDocScreen__block text-input"
        value={answer}
        onChange={handleAnswerClick}
      >
        <option value="" hidden={true} key="no-answer">
          Select
        </option>
        {props.possibleAnswers.map(
          (possibleAnswer: NursingQuestionPossibleAnswer, index: number) => (
            <option key={index} value={possibleAnswer.text}>
              {possibleAnswer.text}
            </option>
          )
        )}
      </select>
    </div>
  );
};

export default React.memo(VBPQuestionDropDown);
